import { render, staticRenderFns } from "./StorageItem.vue?vue&type=template&id=6998d9ea&scoped=true"
import script from "./StorageItem.vue?vue&type=script&lang=js"
export * from "./StorageItem.vue?vue&type=script&lang=js"
import style0 from "./StorageItem.vue?vue&type=style&index=0&id=6998d9ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6998d9ea",
  null
  
)

export default component.exports